import React from 'react';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import {Col, Input, Typography} from 'antd';
import {fieldColProps} from '../gridHelpers';

const TextareaBox = (props) => {
  const {formikProp} = props;
  const textareaField = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[textareaField.name] && props.customEvents[textareaField.name]
    : {};

  return (
    <Col {...fieldColProps(textareaField)}>
      <FieldLabel field={textareaField} />
      <Input.TextArea
        disabled={textareaField.isDisabled ?? false}
        readOnly={textareaField.readonly ?? false}
        rows={textareaField.rows}
        name={textareaField.name}
        value={formikProp.values[textareaField.name] ?? ''}
        onBlur={() => formikProp.setFieldTouched(textareaField.name, true)}
        onChange={(e) => {
          formikProp.setFieldValue(textareaField.name, e.target.value);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](e, formikProp.setFieldValue);
        }}
      />
      {textareaField.note && (
        <Typography.Text type="secondary">{textareaField.note}</Typography.Text>
      )}
      <FieldError name={textareaField.name} />
    </Col>
  );
};

export default TextareaBox;
